import { Box, Typography } from '@material-ui/core'

export const StepFourForm = () => {
	return (
		<Box marginTop="80px">
			<Typography>Title*</Typography>
		</Box>
	)
}
